<nav class="navbar navbar-expand-lg navbar-light  menu ">
    <div class="container-fluid">

        <button *ngIf="variable" type="button" id="sidebarCollapse" class="btn btn-info" (click)="changeClass()">
                <i class="fa fa-bars"></i>
             
            </button>


        <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fa fa-align-justify"></i>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="nav navbar-nav ml-auto">
                <li class="nav-item active">
                    <a class="nav-link" routerLink=""><i class="fa fa-home" aria-hidden="true"></i>home</a>
                </li>
                <div class="dropdown-divider"></div>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown
                  </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">

                        <a *ngIf="!variable" class="dropdown-item" [routerLink]="[ '/login']"><i  aria-hidden="true" class="fa fa-user"></i>Login</a>


                        <a *ngIf="variable" class="dropdown-item" (click)="logout()"><i  aria-hidden="true" class="fa fa-user"></i>Logout</a>




                    </div>
                </li>

            </ul>

        </div>
    </div>
</nav>